import { ShareAltOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Heart, Share } from '../../assets/icons';
import { getReferralLink } from '../../services/authApi/authApi';
import { addOrRemoveToFavouriteAction, updateFavoriteCount } from '../../store/reducer/favoriteSlice';
import { updatePropertyDetails } from '../../store/reducer/propertyDetailSlice';
import { toastNotify } from '../../utils/toastNotify';
import Sharepop from '../Sharepop/Sharepop';
import './ShareLike.scss';
import throttle from 'lodash/throttle'

const ShareLike = (props) => {
  const { showFavourite = true, isHeader = false } = props;
  const { data } = useSelector((state) => state.propertyDetails);
  const userProfileData = useSelector((state) => state.userData.userData);
  const navigate = useNavigate();
  const { propertyId } = useParams();
  const [openSharePopver, setOpenSharePopver] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const popoverRef = useRef(null);
  // TODO : Create SHARE LINKS and change it from props to generated based on location
  const favorite = useMemo(() => {
    return Boolean(data?.data?.isFavourite);
  }, [data?.data?.isFavourite]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.sharepop-wrapper') && !event.target.closest('.popover-button')) {
        setOpenSharePopver(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popoverRef]);

  const onFavouriteFail = () => {
    const newData = {
      ...data,
      data: {
        ...data?.data,
        isFavourite: favorite,
      },
    };
    dispatch(updatePropertyDetails({ ...newData }));
  };
  const throttledReferralLink=throttle(getReferralLink,3000)

  const handleOnShareClick = async () => {
    try {
      const link = localStorage.getItem('referralLink');
      const token = localStorage.getItem('access_token');
      if (!link) {
        navigate('/account/affiliate-program');
        if (location.pathname === '/account/affiliate-program') {
          toastNotify('error', 'Complete Referral Program Process');
          return;
        }
        setOpenSharePopver(false);
        const response = await getReferralLink(token);
        const { referralLink, hasInvested, agreementAccepted, profileCompleted } = response.data;

        if (hasInvested && agreementAccepted && profileCompleted) {
          localStorage.setItem('referralLink', referralLink);
          return;
        } else {
          localStorage.removeItem('referralLink')
        }
        return;
      }
      
      const response = await throttledReferralLink(token);
      const { hasInvested, agreementAccepted, profileCompleted } = response.data;
      if (hasInvested && agreementAccepted && profileCompleted) {
        // If all conditions are passed, open the popover
        setOpenSharePopver(true);
      }else{
        navigate('/account/affiliate-program');
        if (location.pathname === '/account/affiliate-program') {
          toastNotify('error', 'Complete Referral Program Process');
          return;
        }
      }
    } catch (error) {
      toastNotify('error',error?.response?.data?.message)
    }
  };
  const handleOnFavoriteClick = () => {
    if (Object.keys(userProfileData).length) {
      const newData = {
        ...data,
        data: {
          ...data?.data,
          isFavourite: !favorite,
        },
      };
      dispatch(updatePropertyDetails({ ...newData }));
      dispatch(addOrRemoveToFavouriteAction({ propertyId, onFail: onFavouriteFail }));
      if (!favorite) {
        dispatch(updateFavoriteCount());
      }
    } else {
      navigate('/login');
    }
  };

  const { twitterLink = 'https://twitter.com', facebookLink = 'https://facebook.com', linkedinLink = 'https://linkedin.com' } = props;
  return (
    <div className={`${props.className ? props.className : ''} d-flex g-24 text-terracotta share-like`}>
      <div id='share-link' />
      {openSharePopver ? (
        <>
          <Popover
            placement='bottom'
            overlayClassName='sharepop-wrapper'
            getPopupContainer={() => document.getElementById('share-link')}
            content={
              <div>
                <Sharepop twitterLink={twitterLink} facebookLink={facebookLink} linkedinLink={linkedinLink} isHeader={isHeader} />
              </div>
            }
            trigger='click'
            open={openSharePopver}
          >
            {isHeader ? (
              <ShareAltOutlined className='fz-24 text-almost-black popover-button' size={24} onClick={handleOnShareClick} />
            ) : (
              <div className='d-flex g-8 share popover-button'>
                <Share className='cursor-pointer d-sm' size={24} />
                <span className='cursor-pointer d-md fw-600'>Share</span>
              </div>
            )}
          </Popover>
        </>
      ) : (
        <ShareAltOutlined className='fz-24 text-almost-black d-flex' size={24} onClick={handleOnShareClick} />
      )}
      {showFavourite && (
        <button 
          className='d-flex g-8 like'
          onClick={handleOnFavoriteClick}
          aria-label="Mark as favorite"
          type="button"
        >
          <Heart className='cursor-pointer' size={24} fill={favorite ? '#8A4743' : 'none'} />
          <span className='cursor-pointer d-md fw-600'>Favorite</span>
        </button>
      )}
    </div>
  );
};

export default ShareLike;
